<template>
  <div class="page-container">
    <!-- Breadcrumb / Header -->
    <div class="head-title">
      <div class="left">
        <ul class="breadcrumb">
          <li>
            <a href="#" class="active">{{ $t("purchases") }}</a>
          </li>
        </ul>
      </div>
    </div>

    <!-- Main Workspace Card Wrapper -->
    <div class="main-card">
      
      <!-- Key Statistics Summary Widgets -->
      <ul class="box-info">
        <li>
          <div class="icon-box">
            <i class="bi bi-reply-all-fill"></i>
          </div>
          <span class="text">
            <h5>{{ $t("suppliers") }}</h5>
            <p>{{ $t("numbers") }} : <strong>{{ suppliers }}</strong></p>
          </span>
        </li>
        <li>
          <div class="icon-box">
            <i class="bi bi-credit-card-2-front-fill"></i>
          </div>
          <span class="text">
            <h5>{{ $t("bills") }}</h5>
            <p>{{ $t("numbers") }} : <strong>{{ bills }}</strong></p>
          </span>
        </li>
      </ul>

      <!-- Navigation Links Grid -->
      <div class="body-grid">
        <div class="part">
          <h6>{{ $t("purchases") }}</h6>
          <ul>
            <li>
              <i class="bi bi-three-dots-vertical"></i>
              <router-link to="/purchases/AllPurchaseOrder">{{ $t("order") }} {{ $t("purchase") }}</router-link>
            </li>
            <li>
              <i class="bi bi-three-dots-vertical"></i>
              <router-link to="/purchases/AllBills">{{ $t("invoice") }} {{ $t("purchase") }}</router-link>
            </li>
            <li>
              <i class="bi bi-three-dots-vertical"></i>
              <router-link to="/purchases/AllSupplierReceipts">{{ $t("receipts") }} {{ $t("suppliers") }}</router-link>
            </li>
          </ul>
        </div>

        <div class="part">
          <h6>{{ $t("products") }} & {{ $t("item") }}</h6>
          <ul>
            <li>
              <i class="bi bi-three-dots-vertical"></i>
              <router-link to="/purchases/AllProducts">{{ $t("products") }}</router-link>
            </li>
            <li>
              <i class="bi bi-three-dots-vertical"></i>
              <router-link to="/purchases/AllProducts/ProductCategories">{{ $t("item") }}</router-link>
            </li>
            <li>
              <i class="bi bi-three-dots-vertical"></i>
              <router-link to="/purchases/AllProducts/UnitTypes">{{ $t("unit type") }}</router-link>
            </li>
          </ul>
        </div>

        <div class="part">
          <h6>{{ $t("supplier") }}</h6>
          <ul>
            <li>
              <i class="bi bi-three-dots-vertical"></i>
              <router-link to="/purchases/suppliers">{{ $t("suppliers") }}</router-link>
            </li>
          </ul>
        </div>

        <div class="part">
          <h6>{{ $t("reports") }} {{ $t("purchases") }}</h6>
          <ul>
            <li>
              <i class="bi bi-three-dots-vertical"></i>
              <router-link to="purchases/SuplierStatement">{{ $t("Account Statement") }} {{ $t("suppliers") }}</router-link>
            </li>
            <li>
              <i class="bi bi-three-dots-vertical"></i>
              <router-link to="purchases/SuplierBalance">{{ $t("balance") }} {{ $t("suppliers") }}</router-link>
            </li>
          </ul>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapActions } from "vuex";

export default {
  title: "Purchases",
  props: ["css"],
  data() {
    return {
      costomer: 0,
      suppliers: 0,
      invoices: 0,
      bills: 0,
      salles: "",
    };
  },
  async created() {
    try {
      const result = await axios.get(`/reports/homesummary`);
      if (result.status == 200) {
        this.costomer = result.data.customer[0]?.count || 0;
        this.suppliers = result.data.suppliers[0]?.count || 0;
        this.invoices = result.data.invoice[0]?.count || 0;
        this.bills = result.data.bills[0]?.count || 0;
        this.salles = result.data.salles;
      }
    } catch (error) {
      console.error("Failed fetching summaries:", error);
    }
  },
  methods: {
    ...mapActions(["redirectTo"]),
  },
};
</script>

<style lang="scss" scoped>
/* Reset and Container Basics */
.page-container {
  direction: v-bind("css.EN");
  padding: 20px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  background-color: #f8f9fa;
  min-height: 100vh;
}

.breadcrumb {
  list-style: none;
  padding: 0;
  margin-bottom: 20px;
  
  li a {
    text-decoration: none;
    font-weight: 600;
    font-size: 1.2rem;
    color: #333;
    
    &.active {
      color: v-bind("css.color");
    }
  }
}

/* Main Dashboard Card Wrapper */
.main-card {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  padding: 24px;
}

/* Statistics Widgets Block */
.box-info {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  grid-gap: 24px;
  list-style: none;
  padding: 0;
  margin: 0 0 32px 0;

  li {
    padding: 20px;
    background: #f8fafc;
    border: 1px solid #f1f5f9;
    border-radius: 12px;
    display: flex;
    align-items: center;
    grid-gap: 16px;

    .icon-box {
      width: 56px;
      height: 56px;
      border-radius: 10px;
      font-size: 24px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: v-bind("css.color");
      color: #ffffff; /* Adjusted for clear icon visibility against themes */
      opacity: 0.9;
    }

    .text {
      h5 {
        font-size: 18px;
        font-weight: 600;
        color: #1e293b;
        margin: 0 0 4px 0;
      }
      p {
        color: #64748b;
        font-size: 14px;
        margin: 0;
        
        strong {
          color: #0f172a;
        }
      }
    }
  }
}

/* Bottom Navigation Grid System */
.body-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 24px;
}

.part {
  background-color: #ffffff;
  border: 1px solid #edf2f7;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);
  align-self: start;

  h6 {
    font-size: 16px;
    font-weight: 700;
    color: #1a202c;
    margin-top: 0;
    margin-bottom: 16px;
    border-bottom: 2px solid #edf2f7;
    padding-bottom: 8px;
    text-transform: uppercase;
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;

    li {
      display: flex;
      align-items: center;
      margin-bottom: 12px;
      font-size: 15px;

      &:last-child {
        margin-bottom: 0;
      }

      .bi-three-dots-vertical {
        color: #a0aec0;
        margin-right: 8px;
        font-size: 14px;
      }

      a {
        color: #4a5568;
        text-decoration: none;
        transition: color 0.2s;

        &:hover {
          color: v-bind("css.color");
          font-weight: 500;
        }
      }
    }
  }
}

/* Responsive Breakpoints */
@media screen and (max-width: 992px) {
  .body-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media screen and (max-width: 768px) {
  .box-info {
    grid-template-columns: 1fr;
    grid-gap: 16px;
  }
}

@media screen and (max-width: 576px) {
  .page-container {
    padding: 10px;
  }
  
  .main-card {
    padding: 16px;
  }

  .body-grid {
    grid-template-columns: 1fr;
    grid-gap: 16px;
  }
  
  .part {
    padding: 16px;
    
    h6 {
      font-size: 14px;
      margin-bottom: 12px;
    }
    
    ul li {
      font-size: 14px;
      margin-bottom: 10px;
    }
  }
}
</style>